import { HStack, Text, VStack } from "@chakra-ui/react";

import { G1Input } from "@components/G1Input";

interface BillingStepProps {
    tvaIntra: string;
    onTvaIntraChange: (value: string) => void;
}

export default function BillingStep(props: BillingStepProps) {
    const {
       tvaIntra,
        onTvaIntraChange,
    } = props;

    return (
        <VStack spacing={4}>
            <HStack alignSelf="flex-start">
                <Text whiteSpace="nowrap" flexShrink={0} mr={0}>Numéro de TVA intracommunautaire</Text>
                <Text color="red.300">*</Text>
                <G1Input
                    component="connection.form"
                    marginLeft={4}
                    autoFocus
                    textTransform="uppercase"
                    value={tvaIntra}
                    onChange={(e) => onTvaIntraChange(e.target.value)}
                />
            </HStack>
        </VStack>
    );
};